import theme from '../../theme';

const styles = {
  title: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: '10px',
  },
};

export default styles;
